export default __webpack_public_path__ + "logo.dark.2055265680e3bf85604ede62ffaa30c7.svg";